import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Form, Radio, Select } from 'antd'
import React from 'react'
import { type InvoiceConfigurationComponentProps as FreightCalculationOptionsProps } from '../../../../types'
import { FREIGHT_CALCULATION_OPTIONS, FREIGHT_DATE_METHOD_OPTIONS } from '../constants'

export function FreightCalculationOptions({ ratebook, form }: FreightCalculationOptionsProps) {
  return (
    <Vertical className='pt-4' border='top' style={{ overflowX: 'visible' }}>
      <Texto category='h5' weight='600' className='mb-4'>
        Freight Calculation Options
      </Texto>
      <Horizontal gap={16} verticalCenter className='mb-3'>
        <Texto category='p2'>Splits Calculation Config:</Texto>
        <Form.Item name='freight_method' noStyle>
          <Select style={{ width: 200 }} options={FREIGHT_CALCULATION_OPTIONS} />
        </Form.Item>
        <Texto category='p2' style={{ marginLeft: 16 }}>
          Freight Date Method:
        </Texto>
        <Form.Item name='freight_date_method' noStyle>
          <Select style={{ width: 200 }} options={FREIGHT_DATE_METHOD_OPTIONS} />
        </Form.Item>
        <Horizontal gap={16} verticalCenter>
          <Texto category='p1' style={{ whiteSpace: 'nowrap' }}>
            Billing Volume Basis:
          </Texto>
          <Form.Item name='billing_volume_basis' noStyle>
            <Radio.Group style={{ width: 'min-content', whiteSpace: 'nowrap' }} buttonStyle='solid'>
              <Radio.Button value='Net'>Net</Radio.Button>
              <Radio.Button value='Gross'>Gross</Radio.Button>
            </Radio.Group>
          </Form.Item>
        </Horizontal>
      </Horizontal>
    </Vertical>
  )
}
